// Dev-only logging — errors are visible while developing but silent in the
// production bundle, satisfying both debuggability and clean prod consoles.
const isDev = process.env.NODE_ENV !== "production";

export const logError = (...args) => { if (isDev) console.error(...args); };
export const logWarn = (...args) => { if (isDev) console.warn(...args); };
export const logDebug = (...args) => { if (isDev) console.debug(...args); };
